import ApiService from '../../../../../../services/ApiService'
import PieChart from '../../charts/barChart'

export default {
  props: {
    filterProp: Object,
  },
  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      steps: [],
      pageSize: 10,
      header: [
        { text: '', value: '' },
        { text: 'Etapa', value: 'etapa', align: 'center' },
        { text: 'Tempo Total', value: 'tempoTotal', align: 'center' },
        { text: 'Quantidade', value: 'quantidade', align: 'center' },
        { text: 'Tempo Médio', value: 'tempoMedio', align: 'center' },
        {
          text: 'Percentual Tempo Médio',
          value: 'percentualTempoMedio',
          align: 'center',
        },
      ],
      mobileHeader: [
        { text: 'Etapa', value: 'etapa' },
        { text: 'Tempo Total', value: 'tempoTotal' },
        { text: 'Quantidade', value: 'quantidade' },
        { text: 'Tempo Médio', value: 'tempoMedio' },
        { text: 'Percentual Tempo Médio', value: 'percentualTempoMedio' },
      ],
      backgroundColors: [
        '#426483',
        '#BBCF20',
        '#0F3565',
        '#212950',
        '#C4E8F2',
        '#ED8990',
        '#FDB578',
        '#7EE882',
      ],
      timeStepsChartData: {},
      chartOptions: {},
      chartKey: false,
    }
  },

  components: {
    PieChart,
  },

  methods: {
    async listSteps() {
      this.loading = true
      await this.apiService
        .post('reports/servicesOrdersStepTimes', this.filterProp)
        .then((response) => {
          const arr =
            response && Array.isArray(response.content.resultadoFinal)
              ? response.content.resultadoFinal
              : []
          arr.forEach((item, i) => {
            console.log(`Linha ${i}:`, item)
            if (
              !item.etapa ||
              !item.tempoTotal ||
              item.quantidade === undefined ||
              !item.tempoMedio ||
              !item.percentualTempoMedio
            ) {
              console.warn(`Linha ${i} com campo faltando ou inválido!`, item)
            }
          })
          let stepsArr = arr.slice()
          const totalIndex = stepsArr.findIndex(
            (item) => item.etapa === 'Tempo Total Os Mes'
          )
          if (totalIndex !== -1) {
            const [totalRow] = stepsArr.splice(totalIndex, 1)
            stepsArr.push(totalRow)
          }
          this.steps = stepsArr
          this.fillTimeStepsChartData()
          this.fillChartOptions()
        })
        .catch((err) => {
          this.steps = []
        })
      this.loading = false
    },

    requestExcel() {
      // Exporta para Excel usando filtro compatível com o backend
      let filter = { ...this.filterProp, page: 1 }
      // Remove pageSize se existir, pois o backend não usa
      if (filter.pageSize) delete filter.pageSize
      let now = new Date()
      var filename = `TempoMédioEntreEtapas${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/servicesOrdersStepTimesExcel', filter)
        .then((response) => {
          const fileData = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = fileData
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
    },

    fillTimeStepsChartData() {
      // Exclui qualquer variação de 'TempoTotalOsMes' do gráfico
      const etapas = this.steps.filter((item) => {
        if (!item.etapa) return true
        const etapaLower = item.etapa.toLowerCase().replace(/\s/g, '')
        return (
          etapaLower !== 'tempototalosmes' && etapaLower !== 'tempototalosmes'
        )
      })
      this.timeStepsChartData = {
        labels: etapas.map((item) => item.etapa),
        datasets: [
          {
            label: this.$t('Tempo Médio entre Etapas (h)'),
            backgroundColor: this.backgroundColors,
            // Exibe o tempo médio em horas decimais, sem arredondamento
            data: etapas.map((item) => {
              if (!item.tempoMedio) return 0
              const [h, m] = item.tempoMedio.split(':').map(Number)
              return isNaN(h) || isNaN(m) ? 0 : h + m / 60
            }),
            fill: false,
            pointStyle: 'square',
          },
        ],
      }
      // Atualiza as opções do gráfico para mostrar ticks de 6 em 6 horas até 30
      this.chartOptions = {
        responsive: true,
        plugins: {
          legend: { display: true, position: 'bottom' },
          tooltip: { enabled: true },
        },
        scales: {
          y: {
            beginAtZero: true,
            min: 0,
            max: 30,
            ticks: {
              stepSize: 6,
              callback: function (value) {
                return value + 'h'
              },
            },
          },
        },
      }

      setTimeout(() => {
        this.chartKey = !this.chartKey
      }, 500)
    },
    fillChartOptions() {
      this.chartOptions = {
        legend: {
          display: true,
          responsive: false,
          maintainAspectRatio: true,
          labels: { usePointStyle: true },
        },
      }
    },
  },

  async created() {
    await this.listSteps()
  },

  watch: {
    filterProp: {
      handler() {
        this.listSteps()
      },
      deep: true,
    },
  },
}
